var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6406 8.0625L28.6719 12.5H51.3281L48.3594 8.0625C48.125 7.71875 47.7344 7.5 47.3125 7.5H32.6719C32.25 7.5 31.8594 7.70312 31.625 8.0625H31.6406ZM54.6094 3.90625L60.3438 12.5H62.5H70H71.25C73.3281 12.5 75 14.1719 75 16.25C75 18.3281 73.3281 20 71.25 20H70V67.5C70 74.4063 64.4063 80 57.5 80H22.5C15.5937 80 10 74.4063 10 67.5V20H8.75C6.67187 20 5 18.3281 5 16.25C5 14.1719 6.67187 12.5 8.75 12.5H10H17.5H19.6563L25.3906 3.89062C27.0156 1.46875 29.75 0 32.6719 0H47.3125C50.2344 0 52.9687 1.46875 54.5937 3.89062L54.6094 3.90625ZM17.5 20V67.5C17.5 70.2656 19.7344 72.5 22.5 72.5H57.5C60.2656 72.5 62.5 70.2656 62.5 67.5V20H17.5ZM30 30V62.5C30 63.875 28.875 65 27.5 65C26.125 65 25 63.875 25 62.5V30C25 28.625 26.125 27.5 27.5 27.5C28.875 27.5 30 28.625 30 30ZM42.5 30V62.5C42.5 63.875 41.375 65 40 65C38.625 65 37.5 63.875 37.5 62.5V30C37.5 28.625 38.625 27.5 40 27.5C41.375 27.5 42.5 28.625 42.5 30ZM55 30V62.5C55 63.875 53.875 65 52.5 65C51.125 65 50 63.875 50 62.5V30C50 28.625 51.125 27.5 52.5 27.5C53.875 27.5 55 28.625 55 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a44e7f68f744762c4f6bc9fea10afb26.svg";
export { ForwardRef as ReactComponent };